import {cloneDeep} from "lodash";
import frameworkBaseInstance from "fallco-frontend-framework/src/vue/base_instance";
import {computed} from "vue";
import {useComponent} from "fallco-frontend-framework/src/vue/composable/useComponent";

export function UseBaseTableFilter(route, router, filtersRef) {
  const componentUtilities = useComponent();
  const isMobile = computed(() => {
    return componentUtilities.is_mobile_view.value;
  });
  /**
   * Aggiorna i parametri in url in base ai filtri applicati e ai eventuali parametri di default della chiamata
   * @param httpParams
   * @param filtriDaPostare
   * @returns {Promise<void>}
   */
  async function updateURLQuery(httpParams, filtriDaPostare = null) {
    let queryParams = {};

    Object.keys(route.query).forEach((queryKey) => {
      queryParams[queryKey] = route.query[queryKey];

      if (httpParams["params"] !== undefined) {
        Object.keys(httpParams.params).forEach((param) => {
          queryParams[param] = httpParams.params[param] !== undefined ? httpParams.params[param] : route.query[param];
        });
      }
    })

    if (queryParams["filter"] !== undefined) delete queryParams.filter;

    let routerParams = {
      name: httpParams.path,
      query: {
        ...queryParams
      },
    };

    routerParams.query = filtriDaPostare ? {...routerParams.query, ...{filter: stringifyFilters(filtriDaPostare)} } : routerParams.query;

    await router.push(routerParams);
  }

  function isPopolated(value) {
    return value != null && value !== "" && value !== ''
  }

  function isBoolean(obj) {
    return obj.type !== undefined && obj.type == "boolean";
  }

  /**
   * Elabora l'oggetto dei filtri uniformando i valori
   * @returns {{}}
   */
  function prepareFilters(filters) {
    let filtri = cloneDeep(filters);
    if(filtri) {
      let filtriDaPostare = frameworkBaseInstance.BaseVueUtils.prepareDataToPost(
        filtri
      );

      Object.keys(filtriDaPostare).forEach((filtro) => {
        if (!isPopolated(filtriDaPostare[filtro]) || (isBoolean(filtri[filtro]) && filtriDaPostare[filtro] === "0")) {
          delete filtriDaPostare[filtro];
        }
      });

      return filtriDaPostare;
    }

    return filtri;
  }

  /**
   * Da un oggetto filtri si occupa di serializzarlo in una stringa
   * @param filtri
   * @returns {string}
   */
  function stringifyFilters(filtri) {
    let filtriInStringa = "";
    Object.keys(filtri).forEach((filtroKey) => {
      filtriInStringa += filtroKey + "|" + filtri[filtroKey] + "^";
    });

    return filtriInStringa;
  }

  /**
   * converte una stringa di filtri in un JSON
   * @param filtri
   * @returns {{}}
   */
  function convertFilterStringToJson(filtri) {
    let filtriArray = filtri.slice(0, -1).split("^");
    let filtriDaParsare = {};
    let filtroObj = null;
    filtriArray.forEach((filtro) => {
      filtroObj = filtro.split("|");
      filtriDaParsare[filtroObj[0]] = filtroObj[1];
    });

    return filtriDaParsare;
  }

  function formatFilter(name) {
    return name.replaceAll("_", " ");
  }

  function toggleOpen(open = null) {
    if (open !== null) {
      filtersRef.isFiltersTabOpen = open
    } else {
      filtersRef.isFiltersTabOpen = !filtersRef.isFiltersTabOpen;
    }

    if (filtersRef.isFiltersTabOpen && isMobile.value) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }

  return {
    updateURLQuery,
    prepareFilters,
    stringifyFilters,
    convertFilterStringToJson,
    formatFilter,
    toggleOpen
  }
}